import CurrencyFormatter from 'currency-formatter'
import Config from './config'

// 金额格式化
export default function (value) {
  return CurrencyFormatter.format(value, { locale: Config.get('money_format') })
}